const getIcons = () => [
  {
    id: 1,
    name: 'left',
    svg: (
      <g
        fill='none'
        strokeMiterlimit='10'
        fontFamily='none'
        fontSize='none'
        fontWeight='none'
        textAnchor='none'
        style={{ mixBlendMode: 'normal' }}
      >
        <path d='M0 172V0h172v172z'></path>
        <path
          fill='#3498db'
          d='M99.567 150.5c9.524 0 15.207-10.614 9.925-18.54L78.855 86l30.637-45.96c5.282-7.926-.401-18.54-9.925-18.54a11.937 11.937 0 00-9.926 5.31L55.484 78.053a14.332 14.332 0 000 15.903l34.157 51.242a11.948 11.948 0 009.925 5.303z'
        ></path>
      </g>
    ),
    width: 24,
    height: 24,
    viewBox: '0 0 172 172',
  },
  {
    id: 2,
    name: 'right',
    svg: (
      <g
        fill='none'
        strokeMiterlimit='10'
        fontFamily='none'
        fontSize='none'
        fontWeight='none'
        textAnchor='none'
        style={{ mixBlendMode: 'normal' }}
      >
        <path d='M0 172V0h172v172z'></path>
        <path
          fill='#3498db'
          d='M79.615 21.5c-9.525 0-15.201 10.614-9.92 18.54L100.334 86l-30.637 45.96c-5.282 7.926.394 18.54 9.919 18.54 3.984 0 7.71-1.992 9.925-5.31l34.157-51.242a14.332 14.332 0 000-15.903L89.54 26.803a11.939 11.939 0 00-9.925-5.303z'
        ></path>
      </g>
    ),
    width: 24,
    height: 24,
    viewBox: '0 0 172 172',
  },
  {
    id: 3,
    name: 'download',
    svg: (
      <g
        fill='none'
        strokeMiterlimit='10'
        fontFamily='none'
        fontSize='none'
        fontWeight='none'
        textAnchor='none'
        style={{ mixBlendMode: 'normal' }}
      >
        <path d='M0 172V0h172v172z'></path>
        <path
          fill='#000'
          d='M143.781 139.75v-26.875c0-2.284-1.747-4.031-4.031-4.031s-4.031 1.747-4.031 4.031v22.844H36.28v-22.844c0-2.284-1.747-4.031-4.031-4.031s-4.031 1.747-4.031 4.031v26.875c0 2.284 1.747 4.031 4.031 4.031h107.5c2.284 0 4.031-1.747 4.031-4.031zM86 28.219c-2.284 0-4.031 1.747-4.031 4.031v57.513L68.666 76.459c-1.613-1.612-4.166-1.612-5.644 0-1.613 1.613-1.613 4.166 0 5.644l20.156 20.156c.806.807 1.881 1.21 2.822 1.21.94 0 2.016-.403 2.822-1.21l20.156-20.156c1.613-1.612 1.613-4.166 0-5.644-1.612-1.612-4.165-1.612-5.644 0L90.031 89.763V32.25c0-2.284-1.747-4.031-4.031-4.031z'
        ></path>
      </g>
    ),
    width: 24,
    height: 24,
    viewBox: '0 0 172 172',
  },
  {
    id: 4,
    name: 'shuffle',
    svg: (
      <g
        fill='none'
        strokeMiterlimit='10'
        fontFamily='none'
        fontSize='none'
        fontWeight='none'
        textAnchor='none'
        style={{ mixBlendMode: 'normal' }}
      >
        <path d='M0 172V0h172v172z'></path>
        <path
          fill='#fff'
          d='M11.774 7.795a3.73 3.73 0 00-2.772 1.207c-1.612 1.613-1.612 4.167 0 5.645L67.187 72.83c.807.806 1.881 1.21 2.822 1.21.94 0 2.015-.404 2.821-1.21 1.613-1.612 1.613-4.164 0-5.642L14.647 9.002a4.065 4.065 0 00-2.873-1.207zm106.476.268c-2.284 0-4.031 1.746-4.031 4.03 0 2.285 1.747 4.032 4.031 4.032h30.639L8.869 157.353c-1.613 1.612-1.613 4.167 0 5.645.805.806 1.746 1.207 2.82 1.207 1.076 0 2.018-.4 2.825-1.207L154.53 21.904v30.502c0 2.285 1.747 4.031 4.031 4.031 2.285 0 4.032-1.746 4.032-4.03V12.093c0-2.285-1.747-4.032-4.031-4.032zM101.941 97.96a3.732 3.732 0 00-2.771 1.21c-1.613 1.612-1.613 4.164 0 5.643l51.062 51.062h-30.638c-2.285 0-4.031 1.747-4.031 4.031 0 2.285 1.746 4.031 4.03 4.031h40.313c2.285 0 4.031-1.746 4.031-4.03v-40.313c0-2.285-1.746-4.031-4.03-4.031-2.285 0-4.032 1.746-4.032 4.03v30.64L104.812 99.17a4.062 4.062 0 00-2.87-1.21z'
        ></path>
      </g>
    ),
    width: 16,
    height: 16,
    viewBox: '0 0 172 172',
  },
  {
    id: 5,
    name: 'search',
    svg: (
      <g
        fill='none'
        strokeMiterlimit='10'
        fontFamily='none'
        fontSize='none'
        fontWeight='none'
        textAnchor='none'
        style={{ mixBlendMode: 'normal' }}
      >
        <path d='M0 172V0h172v172z'></path>
        <path
          fill='#fff'
          d='M64.5 14.333c-27.621 0-50.167 22.546-50.167 50.167 0 27.621 22.546 50.167 50.167 50.167 12.527 0 23.973-4.673 32.782-12.318l3.051 3.051v9.267l43 43 14.334-14.334-43-43H105.4l-3.051-3.051c7.645-8.81 12.318-20.255 12.318-32.782 0-27.621-22.546-50.167-50.167-50.167zm0 14.334A35.725 35.725 0 01100.333 64.5 35.725 35.725 0 0164.5 100.333 35.725 35.725 0 0128.667 64.5 35.725 35.725 0 0164.5 28.667z'
        ></path>
      </g>
    ),
    width: 18,
    height: 18,
    viewBox: '0 0 172 172',
  },
];

export default getIcons;
